import { IElectron } from 'electron-app/electron.interface';

export class ElectronService {
  public electron: IElectron = window.electron;

  constructor() {
    this.electron.subscribe('updateNotAvailable', () => {
      this.updateNotAvailable();
    });

    this.electron.subscribe('updateAvailable', (remoteVersion) => {
      this.showAvailableUpdate(remoteVersion);
    });

    this.electron.subscribe('updateDownloading', (remoteVersion) => {
      this.updateDownloading(remoteVersion);
    });

    this.electron.subscribe('noChanges', () => {
      console.log('User delayed the update');
    });

    this.electron.subscribe('serverError', (message, err) => {
      console.log(message, err);
    });
  }

  public checkForUpdates(): void {
    this.electron.send('checkForUpdate', true);
  }

  public showAvailableUpdate(remoteVersion: string): void {
    console.log('An update is available ! Remote version : ', remoteVersion);
    this.electron.send('showAvailableUpdate', remoteVersion);
  }

  public updateNotAvailable(): void {
    console.log('No updates are available');
  }

  public updateDownloading(remoteVersion: string): void {
    console.log('downloading...');
    console.log('Remote version : ', remoteVersion);
  }
}
